import { v4 as uuidv4 } from 'uuid';
import type { Feature, FeatureCollection } from 'geojson';
import type { Geometry } from 'geojson';

export interface GeoLocation {
  id: string;
  address: string;
  name: string;
  centroid: Feature;
  geojson: {
    type: 'geojson';
    data: FeatureCollection;
  };
}

export type BuildGeoLocationArgs = {
  geometry: Geometry;
  centroid: Feature;
  address?: string;
  placeName?: string;
  existingId?: string;
};

export const buildGeoLocationFromGeoJson = (
  args: BuildGeoLocationArgs
): GeoLocation => {
  const { geometry, centroid, address, placeName, existingId } = args;

  const featureCollection: FeatureCollection = {
    type: 'FeatureCollection',
    features: [
      {
        type: 'Feature',
        geometry,
        properties: {},
      },
    ],
  };

  return {
    id: existingId || uuidv4(),
    address: address || '',
    name: placeName || address || '',
    centroid,
    geojson: {
      type: 'geojson',
      data: featureCollection,
    },
  };
};
